"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventIdMapping = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Events_1 = require("icf-search-client-shared/lib/services/Events");
exports.eventIdMapping = new Map([
    [Events_1.Events.performerItemClick, 340002],
    [Events_1.Events.pageNextClick, 333108],
    [Events_1.Events.pagePrevClick, 333109],
    [Events_1.Events.autocompleteResultClick, 333101],
    [Events_1.Events.pageNumClick, 333114],
    [Events_1.Events.filterClick, 340005],
    [Events_1.Events.sessionAction, 810001],
]);
//# sourceMappingURL=TrackingEvents.js.map